import dayjs from 'dayjs';
export const setTimeToDate = (date, timeString) => {
    if (!timeString) {
        return date;
    }
    // NOTE: time format is HH:MM AMPM
    const [time, daytime] = timeString.split(' ');
    const [hours, minutes] = time.split(':');
    if (!time || !daytime || !hours || !minutes) {
        return date;
    }
    const parsedHours = parseInt(hours);
    return dayjs(date)
        .set('hour', daytime === 'PM' && parsedHours < 12 ? parsedHours + 12 : parsedHours)
        .minute(parseInt(minutes))
        .toDate();
};
